module.exports = __webpack_public_path__ + "static/media/sp1.e59f68ce.jpg";